import { useEffect, useLayoutEffect } from "react";

/** Same API as `useLayoutEffect` but safe under SSR (avoids hydration mismatch on the homepage). */
export const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;
